/**
 * Centralised React Query key definitions.
 * Import from here — never define query keys inline or inside component files.
 */
export const QUERY_KEYS = {
  stripeInvoices: ["stripe", "invoices"] as const,
  stripeCreditBalance: ["stripe", "credit-balance"] as const,
  termsCurrent: ["terms", "current"] as const,
  authEmail: ["auth", "email"] as const,
} as const;
